import React from 'react'
import axios from 'axios'

import { withRouter } from 'react-router-dom'

import { Chart } from 'primereact/chart';
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button'
import { Toast } from 'primereact/toast';
import { Fieldset } from 'primereact/fieldset';
import { InputNumber } from 'primereact/inputnumber'
import { TabView, TabPanel } from 'primereact/tabview';
import { Card } from 'primereact/card';
import { Calendar } from 'primereact/calendar'
import { locale, addLocale, updateLocaleOption, updateLocaleOptions, localeOption, localeOptions } from 'primereact/api'
import { Dialog } from 'primereact/dialog'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'
import { Dropdown } from 'primereact/dropdown'
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { InputTextarea } from 'primereact/inputtextarea'
import { Tag } from 'primereact/tag';
import { Checkbox } from 'primereact/checkbox'
import { InputText } from 'primereact/inputtext'
import { uniqueId } from "lodash"
import filesize from 'filesize'

import Upload from '../../componentes/Upload/Index'
import FileList from '../../componentes/FileList/index'


import NavBar from '../../componentes/Navbar'
import Progresso from '../../componentes/Progresso'

import FinanceiroService from '../../app/service/FinanceiroService'
import TipoDespesaReceita from '../../app/service/TipoDespesaReceita'
import ProcessoService from '../../app/service/ProcessoService'
import ArquivoFinanceiroService from '../../app/service/ArquivoFinanceiroService'
import ContaFinanceiraService from '../../app/service/ContaFinanceiraService'
import { AuthContext } from '../../main/ProvedorAutenticacao'

import './financeiro.css'

class PainelFinanceiro extends React.Component {
  constructor(props) {
    super(props);

    this.financeiroService = new FinanceiroService();
    this.tipoDespesaReceita = new TipoDespesaReceita();
    this.processoService = new ProcessoService();
    this.arquivoFinanceiroService = new ArquivoFinanceiroService();
    this.contaFinanceiraService = new ContaFinanceiraService();

    this.onDespesaChange = this.onDespesaChange.bind(this);
    this.situacaoDespesa = this.situacaoDespesa.bind(this);
    this.acoesDespesas = this.acoesDespesas.bind(this);
    this.onChangeCategoria = this.onChangeCategoria.bind(this);
    this.acoesProcesso = this.acoesProcesso.bind(this);
    this.renderFooterProcesso = this.renderFooterProcesso.bind(this);
    this.renderFooterCadastro = this.renderFooterCadastro.bind(this);
    this.onChangeOptionSituacao = this.onChangeOptionSituacao.bind(this);
    this.onOptionRecoorencia = this.onOptionRecoorencia.bind(this);
    this.renderFooterConsultaLancamento = this.renderFooterConsultaLancamento.bind(this);
    this.acceptCancelarMassaDespesas = this.acceptCancelarMassaDespesas.bind(this);
    this.acceptCancelarMassaReceitas = this.acceptCancelarMassaReceitas.bind(this);
    this.renderDespesas = this.renderDespesas.bind(this);
    this.renderReceitas = this.renderReceitas.bind(this);
    this.renderPendentes = this.renderPendentes.bind(this);
    this.renderVencendoHoje = this.renderVencendoHoje.bind(this);
    this.acoesArquivosTemp = this.acoesArquivosTemp.bind(this);
    this.acoesArquivos = this.acoesArquivos.bind(this);
    this.acceptExcluirArquivo = this.acceptExcluirArquivo.bind(this);
    this.renderFooterDescricaoArquivo = this.renderFooterDescricaoArquivo.bind(this);
    this.renderFooterDescricaoArquivoTemp = this.renderFooterDescricaoArquivoTemp.bind(this);
    this.onChangeCategoriaConsulta = this.onChangeCategoriaConsulta.bind(this);
    this.onDespesaChangeConsulta = this.onDespesaChangeConsulta.bind(this);
    this.onCriarAtividade = this.onCriarAtividade.bind(this);

    this.state = {
      classeDiv: 'hide',
      detail: '',
      meses: [],
      despesas: [],
      receitas: [],
      pendentes: [],
      modalPendentes: false,
      selectPendentes: null,
      pendenteConsultaTipo: null,
      pendenteConsultaTipoCodigo: null,
      basicaData2: [],
      despesasPeriodo: [],
      totalPagoDespesa: '',
      totalAtivoDespesa: '',
      totalPagosAtivos: '',
      receitasPeriodo: [],
      graficoDespesa: [],
      graficoReceita: [],
      pieDespesas: [],
      pieReceitas: [],
      dataInicial: '',
      dataFinal: '',
      despesaTotal: '',
      receitaTotal: '',
      saldo: '',
      modalDespesas: null,
      modalReceitas: null,
      modalCadastro: null,
      modalConsulta: false,
      modalDespesaPagamento: null,
      modalReceitaPagamento: null,
      selectDespesas: null,
      selectReceitas: null,
      vencendoAmanha: '',
      vencendoHoje: '',
      vencendoHojeLista: [],
      selectVencendoHoje: null,
      vencendoHojeConsultaTipo: '',
      vencendoHojeConsultaTipoCodigo: '',
      modalVencendoHoje: false,
      pendente: '',
      codigoLancamento: '',
      //Novo Lançamento
      lancamento: null,
      tipo: null,
      tipoNome: '',
      dtVencimento: '',
      dtVencimentoConsulta: '',
      vlLancamento: '',
      vlLancamentoSemMascara: '',
      vlLancamentoNovo: '',
      dtVencimentoNovo: '',
      dsLancamento: '',
      observacao: '',
      processo: null,
      processos: [],
      dsProcesso: '',
      modalProcesso: null,
      tipos: [],
      selectCategoria: null,
      categoriaNome: '',
      optionSituacao: null,
      optionRecorrencia: null,
      parcelas: '',
      vlPago: '',
      dtPago: '',
      situacao: '',
      visible: false,
      //Upload de arquivos
      upLoadFiles:[],
      arquivosTemp: [],
      arquivoTemp: null,
      arquivo: null,
      arquivos: [],
      arquivoCodigo: '',
      descricao: '',
      modalDescricaoArquivo: false,
      modalDescricaoArquivoTemp: false,
      openSpinner: false,
      //manipulação do processo
      exibePesquisa: 'block',
      processoPsquisado: '',
      partes: '',
      exibeProcessoPesquisado: 'none',
      atividade: [],
      //Contas Financeiras
      contasFinanceiras: [],
      contaFinanceira: null,
      nomeConta: '',
      //Gráficos de contas Financeiras
      contasDespesas: [],
      contasDepesasPie: null,
      contasReceitas: [],
      contasReceitasPie: null,
    };

    this.statusSituacao = [
      {codigo: 'P', nome: 'Pagos'},
      {codigo: 'A', nome: 'Abertos'},
      {codigo: 'T', nome: 'Todos'}
    ];

    this.categoria = [
      {codigo: 'D', nome: 'Despesa'},
      {codigo: 'R', nome: 'Receita'}
    ];

    this.recorrencia = [
      {codigo: 'S', nome: 'Sem recorrência'},
      {codigo: 'R', nome: 'Repetição'},
      {codigo: 'P', nome: 'Parcelada'}
    ]

    addLocale('es', {
      firstDayOfWeek: 1,
      dayNames: ['Domingo', 'Domingo', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
      dayNamesShort: ['Domingo', 'Domingo', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
      dayNamesMin: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
      monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Stembro', 'Outubro', 'Novembro', 'Dezemro'],
      monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
      today: 'Hoy',
      clear: 'Claro'
    });

    this.chartData = {
      labels: ['A', 'B', 'C'],
      datasets: [
          {
              data: [300, 50, 100],
              backgroundColor: [
                  "#42A5F5",
                  "#66BB6A",
                  "#FFA726"
              ],
              hoverBackgroundColor: [
                  "#64B5F6",
                  "#81C784",
                  "#FFB74D"
              ]
          }
      ]
    };

    this.options = this.getLightTheme();
  }

  listarContasFinanceiras = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.setState({openSpinner: true});
    await this.contaFinanceiraService.listarAtivos(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({contasFinanceiras: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.setState({openSpinner: false});
        this.toast.show({severity:'error', summary: 'Contas Financeiras', detail:`${error}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  //Upload de Documentos
  handleUploadTemp = async files => {
    const upLoadFiles = files.map(file => ({
      file,
      id: uniqueId(),
      name: file.name,
      readableSize: filesize(file.size),
      progress: 0,
      uploaded: false, 
      error: false,
      url: file.url
    }))

    this.setState({
      upLoadFiles: this.state.upLoadFiles.concat(upLoadFiles)
    });

    await upLoadFiles.forEach(this.processarTemp);
  }

  updateFileTemp = (id, data) => {
    this.setState({upLoadFilesTemp: this.state.upLoadFilesTemp.map(upLoadFile => {
      return id === upLoadFile.id ? { ...upLoadFile, ...data } : upLoadFile;
    })})
  }

  processarTemp = async (upLoadFile) => {
    const usuarioLogado = this.context.usuarioAutenticado;
    const data = new FormData();
    data.append('file',upLoadFile.file);
    data.append('usuario',upLoadFile.file, usuarioLogado.codigo) //Envia código de usuário para guardar arquivos
    await this.arquivoFinanceiroService.incluirArquivoTemp(data)
      .then(response => {
        this.handleDelete(upLoadFile.id);
        this.listarArquivosTemp();
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${error}`, life: 4000});
      })
  }

  excluirArquivosTemp = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.arquivoFinanceiroService.excluirArquivosTemp(usuarioLogado.codigo)
      .then(response => {
        this.listarArquivosTemp();
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${error}`, life: 4000});
      })
  }

  handleDelete  = async id => {
    this.setState({upLoadFiles: this.state.upLoadFiles.filter(file => file.id !== id)});
  } 

  listarArquivosTemp = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.arquivoFinanceiroService.listarArquivosTemp(usuarioLogado.codigo)
      .then(response => {
        this.setState({arquivosTemp: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${error}`, life: 4000});
      })
  }

  acoesArquivosTemp(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-comment" className="p-button-rounded p-button-text"
                tooltip="Adicionar descrição ao arquivo"
                tooltipOptions={{position: 'top'}}
                onClick={() => this.consultarArquivoDescricaoTemp(rowData)}
                style={{width: '20px', height: '10px'}}/>
        &nbsp;
        <Button icon="pi pi-cloud-download" className="p-button-rounded p-button-text"
                tooltip="Baixar Arquivo"
                tooltipOptions={{position: 'top'}}
                onClick={() => this.downloadTemp(rowData)}
                style={{width: '20px', height: '10px'}}/>
        &nbsp;
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                tooltip="Excluir Arquivo"
                onClick={() => this.excluirArquivoTemp(rowData.codigo)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
      </React.Fragment>
    );
  }

  consultarArquivoTemp = async (codigo) => {
    this.arquivoFinanceiroService.consultarArquivoTemp(codigo)
      .then(response => {
        this.setState({arquivoTemp: response.data});
        this.setState({descricao: response.data.descricao});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${error}`, life: 4000});
      })
  }

  consultarArquivoDescricaoTemp = async (rowData) => {
    this.arquivoFinanceiroService.consultarArquivoTemp(rowData.codigo)
      .then(response => {
        this.setState({arquivoTemp: response.data});
        this.setState({descricao: response.data.descricao});
        this.abrirModalDescricaoArquivo('modalDescricaoArquivoTemp');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${error}`, life: 4000});
      });
  }

  async downloadTemp (rowData){
    await this.consultarArquivoTemp(rowData.codigo);
    await this.arquivoFinanceiroService.downloadTemp(rowData.codigo)
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.state.arquivoTemp.arquivo); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
  }

  excluirArquivoTemp(codigo) {
    this.arquivoFinanceiroService.excluirArquivoTemp(codigo)
      .then(response => {
        this.listarArquivosTemp();
        this.toast.show({severity:'success', summary: 'Arquivos', detail:'Arquivo excluído com sucesso', life: 4000});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${error}`, life: 4000});
      })
  }

  //Upload de Documentos Originais
  handleUpload = async files => {
    const upLoadFiles = files.map(file => ({
      file,
      id: uniqueId(),
      name: file.name,
      readableSize: filesize(file.size),
      progress: 0,
      uploaded: false, 
      error: false,
      url: file.url
    }))

    this.setState({
      upLoadFiles: this.state.upLoadFiles.concat(upLoadFiles)
    });

    await upLoadFiles.forEach(this.processar);
  }

  updateFile = (id, data) => {
    this.setState({upLoadFiles: this.state.upLoadFiles.map(upLoadFile => {
      return id === upLoadFile.id ? { ...upLoadFile, ...data } : upLoadFile;
    })})
  }

  processar = async (upLoadFile) => {
    const usuarioLogado = this.context.usuarioAutenticado;
    const data = new FormData();
    data.append('file',upLoadFile.file);
    data.append('usuario',upLoadFile.file, usuarioLogado.codigo) //Envia código de usuário para guardar arquivos
    data.append('lancamento',upLoadFile.file, this.state.lancamento.codigo)
    await this.arquivoFinanceiroService.incluirArquivo(data)
      .then(response => {
        this.handleDelete(upLoadFile.id);
        this.listarArquivos(this.state.lancamento.codigo);
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${error}`, life: 4000});
      })
  }

  confirmaExclusaoArquivo(arquivo) {
    this.setState({arquivoCodigo: arquivo.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir este arquivo?',
        header: 'Exclusão de Arquivos',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.acceptExcluirArquivo,
        reject: this.reject
    });
  }

  acceptExcluirArquivo() {
    console.log('Arquivo a ser excluido', this.state.arquivoCodigo)
    this.excluirArquivo(this.state.arquivoCodigo);
  }

  excluirArquivo(codigo) {
    this.arquivoFinanceiroService.excluirArquivo(codigo)
      .then(response => {
        this.listarArquivos(this.state.lancamento.codigo);
        this.toast.show({severity:'success', summary: 'Exclusão de Arquivos', detail:'Arquivo excluído com sucesso', life: 4000});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${error}`, life: 4000});
      })
  }

  listarArquivos = (lancamento) => {
    this.arquivoFinanceiroService.listarArquivos(lancamento)
      .then(response => {
        this.setState({arquivos: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Financeiro - Arquivos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  acoesArquivos(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-comment" className="p-button-rounded p-button-text"
                tooltip="Adicionar descrição ao arquivo"
                tooltipOptions={{position: 'top'}}
                onClick={() => this.consultarArquivoDescricao(rowData)}
                style={{width: '20px', height: '10px'}}/>
        &nbsp;
        <Button icon="pi pi-cloud-download" className="p-button-rounded p-button-text"
                tooltip="Baixar Arquivo"
                tooltipOptions={{position: 'top'}}
                onClick={() => this.download(rowData)}
                style={{width: '20px', height: '10px'}}/>
        &nbsp;
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                tooltip="Excluir Arquivo"
                onClick={() => this.confirmaExclusaoArquivo(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
      </React.Fragment>
    );
  }

  consultarArquivo = async (codigo) => {
    this.arquivoFinanceiroService.consultarArquivo(codigo)
      .then(response => {
        this.setState({arquivo: response.data})
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${error}`, life: 4000});
      })
  }

  consultarArquivoDescricao = async (rowData) => {
    this.arquivoFinanceiroService.consultarArquivo(rowData.codigo)
      .then(response => {
        this.setState({arquivo: response.data})
        this.setState({descricao: response.data.descricao});
        this.abrirModalDescricaoArquivo('modalDescricaoArquivo');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${error}`, life: 4000});
      });
  }

  adicionarDescricao = () => {
    const arquivo = {
      codigo: this.state.arquivo.codigo,
      descricao: this.state.descricao
    }

    this.arquivoFinanceiroService.adicionarDescricao(arquivo)
      .then(response => {
        this.listarArquivos(this.state.lancamento.codigo);
        this.toast.show({severity:'success', summary: 'Descrição do Arquivo', detail:'Descrição adicionada com sucesso', life: 4000});
        this.fecharModalCadastro('modalDescricaoArquivo');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${error}`, life: 4000});
      })
  }

  adicionarDescricaoTemp = () => {
    const arquivo = {
      codigo: this.state.arquivoTemp.codigo,
      descricao: this.state.descricao
    }
    const usuarioLogado = this.context.usuarioAutenticado;
    this.arquivoFinanceiroService.adicionarDescricaoTemp(arquivo)
      .then(response => {
        this.listarArquivosTemp(usuarioLogado.codigo); 
        this.toast.show({severity:'success', summary: 'Descrição do Arquivo', detail:'Descrição adicionada com sucesso', life: 4000});
        this.fecharModalCadastro('modalDescricaoArquivoTemp');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${error}`, life: 4000});
      })
  }

  abrirModalDescricaoArquivo(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  async download (rowData){
    await this.consultarArquivo(rowData.codigo);
    await this.arquivoFinanceiroService.download(rowData.codigo)
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.state.arquivo.arquivo); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
  }

  renderFooterDescricaoArquivo(name) {
    return (
        <div>
            <button type="button" 
                    className="btn btn-primary bg-gradient-secondary" 
                    onClick={() => this.fecharModalCadastro('modalDescricaoArquivo')}>
                <i className="fas fa-times"></i> Cancelar
            </button>
            <button type="button" className="btn btn-primary bg-gradient-success"
                    onClick={this.adicionarDescricao}>
                <i className="fas fa-check"></i> Alterar
            </button>
        </div>
    );
  }
  renderFooterDescricaoArquivoTemp(name) {
    return (
        <div>
            <button type="button" 
                    className="btn btn-primary bg-gradient-secondary" 
                    onClick={() => this.fecharModalCadastro('modalDescricaoArquivoTemp')}>
                <i className="fas fa-times"></i> Cancelar
            </button>
            <button type="button" className="btn btn-primary bg-gradient-success"
                    onClick={this.adicionarDescricaoTemp}>
                <i className="fas fa-check"></i> Alterar
            </button>
        </div>
    );
  }

  fecharModalCadastro(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  detalharPendentes = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
  
    var categoria = null;
    if(this.state.pendenteConsultaTipo != null) {
      categoria = this.state.pendenteConsultaTipo.codigo;
    }

    var tipo = null;
    if(this.state.pendenteConsultaTipoCodigo != null) {
      tipo = this.state.pendenteConsultaTipoCodigo.codigo;
    }

    await this.financeiroService.detalharPendentes(usuarioLogado.empresa.codigo, tipo, categoria)
      .then(response => {
        this.setState({pendentes: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Financeiro - Detalhar pendentes', detail:`${this.state.detail}`, life: 4000});
      });
  }

  async abrirModalPendentes(name, position) {
    this.setState({openSpinner: true});
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    //await this.setState({pendenteConsultaTipoCodigo: null});
    //await this.setState({pendenteConsultaTipo: null});
    await this.detalharPendentes();
    this.setState({openSpinner: false});
    this.setState(state);
  }

  renderPendentes() {
    return (
      <div>
          <Button label="Cancelar Lançamento" 
                  className="p-button-danger p-button-text" 
                  onClick={this.confirmaCancelamentoMassaDespesas}/>
          &nbsp;
          <Button label="Fechar" 
                  className="p-button-secondary p-button-text"
                  onClick={() => this.fecharModal('modalPendentes')}/>

      </div>
    );
  }

  detalharVencendoHoje = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.financeiroService.detalharVencendoHoje(usuarioLogado.empresa.codigo, this.state.vencendoHojeConsultaTipoCodigo, this.state.vencendoHojeConsultaTipo)
      .then(response => {
        this.setState({vencendoHojeLista: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Financeiro - Detalhar Vencendo Hoje', detail:`${this.state.detail}`, life: 4000});
      });
  }

  async abrirModalVencendoHoje(name, position) {
    this.setState({openSpinner: true});
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    await this.detalharVencendoHoje();
    this.setState({openSpinner: false});
    this.setState(state);
  }

  renderVencendoHoje() {
    return (
      <div>
          <Button label="Cancelar Lançamento" 
                  className="p-button-danger p-button-text" 
                  onClick={this.confirmaCancelamentoMassaDespesas}/>
          &nbsp;
          <Button label="Fechar" 
                  className="p-button-secondary p-button-text"
                  onClick={() => this.fecharModal('modalVencendoHoje')}/>

      </div>
    );
  }

  vencendoAmanha = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.financeiroService.vencendoAmanha(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({vencendoAmanha: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Financeiro - Vencendo Amanhã', detail:`${this.state.detail}`, life: 4000});
      });

      const valor = this.state.vencendoAmanha.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
      this.setState({vencendoAmanha: valor});
  }

  vencendoHoje = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.financeiroService.vencendoHoje(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({vencendoHoje: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Financeiro - Vencendo Hoje', detail:`${this.state.detail}`, life: 4000});
      });                                                                                                                                                               

      const valor = this.state.vencendoHoje.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
      this.setState({vencendoHoje: valor});
  }

  pendente = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.financeiroService.pendente(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({pendente: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Financeiro - Pendente', detail:`${this.state.detail}`, life: 4000});
      });                                                                                                                                                               

      const valor = this.state.pendente.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
      this.setState({pendente: valor});
  }

  listarTiposDespesas = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.tipoDespesaReceita.listarTiposDespesasReceitasPorTipo(usuarioLogado.empresa.codigo, 'D')
      .then(response => {
        this.setState({tipos: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Financeiro - Tipos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  listarTiposReceitas = () => {
    const usuarioLogado = this.context.usuarioAutenticado;

    this.tipoDespesaReceita.listarTiposDespesasReceitasPorTipo(usuarioLogado.empresa.codigo, 'R')
      .then(response => {
        this.setState({tipos: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Financeiro - Tipos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  onDespesaChange(e) {
    this.setState({ tipo: e.value });
  }

  onDespesaChangeConsulta(e) {
    this.setState({ pendenteConsultaTipoCodigo: e.value });
  }

  onOptionRecoorencia(e) {
    this.setState({ optionRecorrencia: e.value });
  }

  onChangeOptionSituacao(e) {
    this.setState({optionSituacao: e.value});
  }

  async onChangeCategoria(e) {
    await this.setState({selectCategoria: e.value});
    if(this.state.selectCategoria.codigo == 'D') {
      this.listarTiposDespesas();
    } else {
      this.listarTiposReceitas();
    }
  }

  async onChangeCategoriaConsulta(e) {
    await this.setState({pendenteConsultaTipo: e.value});
    if(this.state.pendenteConsultaTipo.codigo == 'D') {
      this.listarTiposDespesas();
    } else {
      this.listarTiposReceitas();
    }
  }

  consultarProcessoPorIndice = async() => {
    const usuarioLogado = this.context.usuarioAutenticado
    const indice = {
      indice: this.state.dsProcesso,
      empresa: usuarioLogado.empresa.codigo,
      usuario: usuarioLogado.codigo
    }

    this.setState({openSpinner: true});
    await this.processoService.consultarProcessoPorIndice(indice)
      .then(response => {
        this.setState({processos: response.data});
        this.abrirModalProcesso('modalProcesso');
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  abrirModalProcesso(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  acoesProcesso(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-check" className="p-button-rounded p-button-text" 
                tooltip="Selecionar"
                onClick={() => this.selecionarProcesso(rowData)}
                tooltipOptions={{position: 'top'}} />
      </React.Fragment>
    );
  }

  renderFooterProcesso(name) {
    return (
        <div className="left">
            <Button label="Fechar" 
                    className="p-button-secondary p-button-text"
                    onClick={() => this.fecharModal(name)}/>
        </div>
    );
  }

  excluirPesquisaProcesso = () => {
    this.setState({processo: null});
    this.setState({dsProcesso: ''});
    this.setState({partes: null});
    this.setState({exibePesquisa: 'block'});
    this.setState({exibeProcessoPesquisado: 'none'});
  }

  async selecionarProcesso(processo) {
    const usuarioLogado = this.context.usuarioAutenticado
    this.setState({openSpinner: true});
    await this.processoService.consultarProcessoPorCodigo(processo.codigo,usuarioLogado.codigo)
      .then(response => {
        this.setState({processo: response.data});
        this.setState({dsProcesso: processo.nrCnj});
        this.setState({partes: response.data.partes});
        this.setState({exibePesquisa: 'none'});
        this.setState({exibeProcessoPesquisado: 'block'});
        this.fecharModal('modalProcesso');
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Financeiro - Processo', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  formatCurrency(value) {
    return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  consultarDespesasFiltro = async () => {
    const usuarioLogado = this.context.usuarioAutenticado

    //Data Inicial
    var dataFormatadaInicial = '';
    if(this.state.dataInicial != '') {
      var date = this.state.dataInicial;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      dataFormatadaInicial =  year+"-"+month+"-"+day;
    }

    //Data final
    var dataFormatadaFinal = '';
    if(this.state.dataFinal != '') {
      var date = this.state.dataFinal;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      dataFormatadaFinal =  year+"-"+month+"-"+day;
    }

    var pagos = 0;
    var ativos = 0;
    await this.financeiroService.lancamentosPorTipoPeriodo(usuarioLogado.empresa.codigo, dataFormatadaInicial,dataFormatadaFinal,'D')
      .then(response => {
        this.setState({despesasPeriodo: response.data});
        if(response.data.length > 0) {
          for(let i = 0; i < response.data.length; i++) {
            if(response.data[i].situacao == 'P') {
              pagos = pagos + response.data[i].vlPago;
            } else if(response.data[i].situacao == 'A') {
              ativos = ativos + response.data[i].vlLancamento;
            }
          }
          this.setState({totalPagoDespesa: this.formatCurrency(pagos)});
          this.setState({totalAtivoDespesa: this.formatCurrency(ativos)});
          this.setState({totalPagosAtivos: this.formatCurrency(pagos + ativos)});
        }
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Financeiro - Despesas', detail:`${this.state.detail}`, life: 4000});
      });
  }

  filtrarTipoDespesaPeriodo = async () => {
    const usuarioLogado = this.context.usuarioAutenticado
    //Data Inicial
    var dataFormatadaInicial = '';
    if(this.state.dataInicial != '') {
      var date = this.state.dataInicial;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      dataFormatadaInicial =  year+"-"+month+"-"+day;
    }

    //Data final
    var dataFormatadaFinal = '';
    if(this.state.dataFinal != '') {
      var date = this.state.dataFinal;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      dataFormatadaFinal =  year+"-"+month+"-"+day;
    }
    
    var tipoSelecao = '0';
    if(this.state.tipo == null) {
      tipoSelecao = '0';
    } else {
      tipoSelecao = this.state.tipo.codigo;
    }
  
    if(this.state.optionSituacao == null) {
      await this.setState({optionSituacao: {
        codigo: 'T',
        nome: 'Todos'
      }})
    }
    
    var pagos = 0;
    var ativos = 0;
    this.setState({openSpinner: true});
    await this.financeiroService.lancamentosPorTipoDescricaoPeriodo(usuarioLogado.empresa.codigo, dataFormatadaInicial, dataFormatadaFinal,
      tipoSelecao, 'D', this.state.optionSituacao.codigo).then(response => {
        this.setState({despesasPeriodo: response.data});
        if(response.data.length > 0) {
          for(let i = 0; i < response.data.length; i++) {
            if(response.data[i].situacao == 'P') {
              pagos = pagos + response.data[i].vlPago;
            } else if(response.data[i].situacao == 'A') {
              ativos = ativos + response.data[i].vlLancamento;
            }
          }
          this.setState({totalPagoDespesa: this.formatCurrency(pagos)});
          this.setState({totalAtivoDespesa: this.formatCurrency(ativos)});
          this.setState({totalPagosAtivos: this.formatCurrency(pagos + ativos)});
        }
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Financeiro - Despesas - Filtro', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  filtrarTipoReceitasPeriodo = async () => {
    const usuarioLogado = this.context.usuarioAutenticado

    //Data Inicial
    var dataFormatadaInicial = '';
    if(this.state.dataInicial != '') {
      var date = this.state.dataInicial;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      dataFormatadaInicial =  year+"-"+month+"-"+day;
    }

    //Data final
    var dataFormatadaFinal = '';
    if(this.state.dataFinal != '') {
      var date = this.state.dataFinal;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      dataFormatadaFinal =  year+"-"+month+"-"+day;
    }
    
    var tipoSelecao = '0';
    if(this.state.tipo == null) {
      tipoSelecao = '0';
    } else {
      tipoSelecao = this.state.tipo.codigo;
    }

    if(this.state.optionSituacao == null) {
      await this.setState({optionSituacao: {
        codigo: 'T',
        nome: 'Todos'
      }})
    }

    var pagos = 0;
    var ativos = 0;
    this.setState({openSpinner: true});
    await this.financeiroService.lancamentosPorTipoDescricaoPeriodo(usuarioLogado.empresa.codigo, dataFormatadaInicial, dataFormatadaFinal,
      tipoSelecao, 'R', this.state.optionSituacao.codigo).then(response => {
        this.setState({receitasPeriodo: response.data});
        if(response.data.length > 0) {
          for(let i = 0; i < response.data.length; i++) {
            if(response.data[i].situacao == 'P') {
              pagos = pagos + response.data[i].vlPago;
            } else if(response.data[i].situacao == 'A') {
              ativos = ativos + response.data[i].vlLancamento;
            }
          }
          this.setState({totalPagoDespesa: this.formatCurrency(pagos)});
          this.setState({totalAtivoDespesa: this.formatCurrency(ativos)});
          this.setState({totalPagosAtivos: this.formatCurrency(pagos + ativos)});
        }
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Financeiro - Receitas - Filtro', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  consultarReceitasFiltro = async () => {
    const usuarioLogado = this.context.usuarioAutenticado

    //Data Inicial
    var dataFormatadaInicial = '';
    if(this.state.dataInicial != '') {
      var date = this.state.dataInicial;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      dataFormatadaInicial =  year+"-"+month+"-"+day;
    }

    //Data final
    var dataFormatadaFinal = '';
    if(this.state.dataFinal != '') {
      var date = this.state.dataFinal;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      dataFormatadaFinal =  year+"-"+month+"-"+day;
    }

    var pagos = 0;
    var ativos = 0;
    this.setState({openSpinner: true});
    await this.financeiroService.lancamentosPorTipoPeriodo(usuarioLogado.empresa.codigo, dataFormatadaInicial,dataFormatadaFinal, 'R')
      .then(response => {
        this.setState({receitasPeriodo: response.data});
        if(response.data.length > 0) {
          for(let i = 0; i < response.data.length; i++) {
            if(response.data[i].situacao == 'P') {
              pagos = pagos + response.data[i].vlPago;
            } else if(response.data[i].situacao == 'A') {
              ativos = ativos + response.data[i].vlLancamento;
            }
          }
          this.setState({totalPagoDespesa: this.formatCurrency(pagos)});
          this.setState({totalAtivoDespesa: this.formatCurrency(ativos)});
          this.setState({totalPagosAtivos: this.formatCurrency(pagos + ativos)});
        }
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Financeiro - Despesas', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  consultarGraficosDespesas = async (dataInciial, dataFinal) => {
    const usuarioLogado = this.context.usuarioAutenticado

    //Data Inicial
    var dataFormatadaInicial = '';
    if(this.state.dataInicial != '') {
      var date = this.state.dataInicial;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      dataFormatadaInicial =  year+"-"+month+"-"+day;
    }

    //Data final
    var dataFormatadaFinal = '';
    if(this.state.dataFinal != '') {
      var date = this.state.dataFinal;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      dataFormatadaFinal =  year+"-"+month+"-"+day;
    }

    await this.financeiroService.lancamentoGrafico(usuarioLogado.empresa.codigo, dataFormatadaInicial, dataFormatadaFinal, 'D')
      .then(response => {
        this.setState({graficoDespesa: response.data})
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Financeiro - Gráficos', detail:`${this.state.detail}`, life: 4000});
      });

      //Tipos
      let tipos = [];
      for(let i = 0; i < this.state.graficoDespesa.length; i++) {
        tipos.push(this.state.graficoDespesa[i].tipo);
      }
      //Cores
      let cores = [];
      for(let i = 0; i < this.state.graficoDespesa.length; i++) {
        cores.push(this.state.graficoDespesa[i].cor);
      }

      //Valor
      let valores = [];
      for(let i = 0; i < this.state.graficoDespesa.length; i++) {
        valores.push(this.state.graficoDespesa[i].valor);
      }

      this.setState({pieDespesas: {
        labels: tipos,
        datasets: [
          {
            data: valores,
            backgroundColor: cores,
          }
        ]
      }})
  }

  graficoLancamentosContaDespesa = async (dataInciial, dataFinal) => {
    const usuarioLogado = this.context.usuarioAutenticado
    //Data Inicial
    var dataFormatadaInicial = '';
    if(dataInciial != '') {
      var date = dataInciial;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      dataFormatadaInicial =  year+"-"+month+"-"+day;
    }

    //Data final
    var dataFormatadaFinal = '';
    if(dataFinal != '') {
      var date = dataFinal;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      dataFormatadaFinal =  year+"-"+month+"-"+day;
    }

    await this.financeiroService.lancamentosPorConta(usuarioLogado.empresa.codigo,dataFormatadaInicial,dataFormatadaFinal,'D')
      .then(response => {
        this.setState({contasDespesas: response.data})
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Financeiro - Gráficos - lançamentos por conta', detail:`${this.state.detail}`, life: 4000});
      });

      //Contas
      let contas = [];
      for(let i = 0; i < this.state.contasDespesas.length; i++) {
        contas.push(this.state.contasDespesas[i].conta);
      }
      //Cores
      let cores = [];
      for(let i = 0; i < this.state.contasDespesas.length; i++) {
        cores.push(this.state.contasDespesas[i].cor);
      }

      //Valor
      let valores = [];
      for(let i = 0; i < this.state.contasDespesas.length; i++) {
        valores.push(this.state.contasDespesas[i].valor);
      }

      this.setState({contasDepesasPie: {
        labels: contas,
        datasets: [
          {
            data: valores,
            backgroundColor: cores,
          }
        ]
      }})
  }

  graficoLancamentosContaReceita = async (dataInciial, dataFinal) => {
    const usuarioLogado = this.context.usuarioAutenticado
    //Data Inicial
    var dataFormatadaInicial = '';
    if(this.state.dataInicial != '') {
      var date = this.state.dataInicial;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      dataFormatadaInicial =  year+"-"+month+"-"+day;
    }

    //Data final
    var dataFormatadaFinal = '';
    if(this.state.dataFinal != '') {
      var date = this.state.dataFinal;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      dataFormatadaFinal =  year+"-"+month+"-"+day;
    }

    await this.financeiroService.lancamentosPorConta(usuarioLogado.empresa.codigo,dataInciial,dataFinal,'R')
      .then(response => {
        this.setState({contasReceitas: response.data})
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Financeiro - Gráficos - lançamentos por conta', detail:`${this.state.detail}`, life: 4000});
      });

      //Contas
      let contas = [];
      for(let i = 0; i < this.state.contasReceitas.length; i++) {
        contas.push(this.state.contasReceitas[i].conta);
      }
      //Cores
      let cores = [];
      for(let i = 0; i < this.state.contasReceitas.length; i++) {
        cores.push(this.state.contasReceitas[i].cor);
      }

      //Valor
      let valores = [];
      for(let i = 0; i < this.state.contasReceitas.length; i++) {
        valores.push(this.state.contasReceitas[i].valor);
      }

      this.setState({contasReceitasPie: {
        labels: contas,
        datasets: [
          {
            data: valores,
            backgroundColor: cores,
          }
        ]
      }})
  }

  consultarGraficosReceitas = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;

    //Data Inicial
    var dataFormatadaInicial = '';
    if(this.state.dataInicial != '') {
      var date = this.state.dataInicial;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      dataFormatadaInicial =  year+"-"+month+"-"+day;
    }

    //Data final
    var dataFormatadaFinal = '';
    if(this.state.dataFinal != '') {
      var date = this.state.dataFinal;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      dataFormatadaFinal =  year+"-"+month+"-"+day;
    }

    await this.financeiroService.lancamentoGrafico(usuarioLogado.empresa.codigo, dataFormatadaInicial, dataFormatadaFinal, 'R')
      .then(response => {
        this.setState({graficoReceitas: response.data})
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Financeiro - Gráficos', detail:`${this.state.detail}`, life: 4000});
      });

      //Tipos
      let tipos = [];
      for(let i = 0; i < this.state.graficoReceitas.length; i++) {
        tipos.push(this.state.graficoReceitas[i].tipo);
      }
      //Cores
      let cores = [];
      for(let i = 0; i < this.state.graficoReceitas.length; i++) {
        cores.push(this.state.graficoReceitas[i].cor);
      }

      //Valor
      let valores = [];
      for(let i = 0; i < this.state.graficoReceitas.length; i++) {
        valores.push(this.state.graficoReceitas[i].valor);
      }

      this.setState({pieReceitas: {
        labels: tipos,
        datasets: [
          {
            data: valores,
            backgroundColor: cores,
          }
        ]
      }})
  }

  consultaUnica = async () => {
    this.setState({openSpinner: true});
    await this.consultarGraficosDespesas(this.state.dataInicial, this.state.dataFinal);
    await this.consultarGraficosReceitas(this.state.dataInicial, this.state.dataFinal);
    //await this.graficoLancamentosContaDespesa(this.state.dataInicial, this.state.dataFinal);
    //await this.graficoLancamentosContaReceita(this.state.dataInicial, this.state.dataFinal);
    await this.vencendoAmanha();
    await this.vencendoHoje();
    await this.pendente();
    
    var totalDespesas = 0;
    var totalReceitas = 0;

    for(let i = 0; i < this.state.graficoDespesa.length; i++) {
      totalDespesas = totalDespesas + this.state.graficoDespesa[i].valor;
    }

    for(let i = 0; i < this.state.graficoReceitas.length; i++) {
      totalReceitas = totalReceitas + this.state.graficoReceitas[i].valor;
    }

    var totralSaldo = totalReceitas - totalDespesas;

    var despesaFormat = totalDespesas.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
    var receitaFormat = totalReceitas.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
    var saldoFormat = totralSaldo.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});

    this.setState({despesaTotal: despesaFormat});
    this.setState({receitaTotal: receitaFormat});
    this.setState({saldo: saldoFormat});
    this.setState({openSpinner: false});
  }

  pad2 = (n) => {
    return (n < 10 ? '0' : '') + n;
  }

  consultarDespesasxReceitas = async (empresa) => {
    await this.consultarDepesas(empresa);
    await this.consultarReceitas(empresa);
    
    let nomesMeses = [];

    for(let i = 0; i < this.state.meses.length; i++) {
      nomesMeses.push(this.state.meses[i].mes);
    }
    
    let despesas = [];
    for(let i = 0; i < this.state.despesas.length; i++) {
      despesas.push(this.state.despesas[i].total);
    }

    let receitas = [];
    for(let j = 0; j < this.state.receitas.length; j++) {
      receitas.push(this.state.receitas[j].total);
    }

    await this.setState({basicData2: {
      labels: nomesMeses,
      datasets: [
        {

          label: 'Despesa',
          backgroundColor: '#FF0000',
          data: despesas
        },
        {

          label: 'Receita',
          backgroundColor: '#008000',
          data: receitas
        }
      ]
    }})
  }

  consultarDepesas = async (empresa) => {
    await this.financeiroService.depesasPorMes(empresa)
      .then(response => {
        this.setState({despesas: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Financeiro - Despesas', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultarReceitas = async (empresa) => {
    await this.financeiroService.receitasPorMes(empresa)
    .then(response => {
      this.setState({receitas: response.data});
    }).catch(error => {
      this.setState(error.response.data);
      this.toast.show({severity:'error', summary: 'Financeiro - Receitas', detail:`${this.state.detail}`, life: 4000});
    })
  }

  listarMeses = async () => {
    await this.financeiroService.listarMeses()
      .then(response => {
        this.setState({meses: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Financeiro - Meses', detail:`${this.state.detail}`, life: 4000});
      })
  }

  async consultarLancamento(lancamento) {
    this.setState({openSpinner: true});
    await this.financeiroService.consultarLancamento(lancamento.codigo)
      .then(response => {
        this.setState({lancamento: response.data});
        this.setState({codigoLancamento: response.data.codigo});
        //this.setState({tipo: response.data.tipo});
        this.setState({categoriaNome: response.data.categoria});
        this.setState({tipoNome: response.data.tipo.nome});
        this.setState({vlLancamento: this.formatCurrency(response.data.vlLancamento)});
        this.setState({vlLancamentoSemMascara: response.data.vlLancamento}); 
        this.setState({dtVencimento: response.data.dtVencimento});
        this.setState({vlPago: this.formatCurrency(response.data.vlPago)});
        this.setState({dtPago: response.data.dtPago});
        this.setState({dsLancamento: response.data.dsLancamento});
        this.setState({observacao: response.data.observacao});
        if(response.data.conta != null) {
          this.setState({nomeConta: response.data.conta.nomeFormat});
        } else {
          this.setState({nomeConta: ''});
        }
        if(response.data.processo != null) {
          this.setState({dsProcesso: response.data.processo.nrCnj});
          this.setState({exibePesquisa: 'block'});
          this.setState({partes: response.data.processo.partes});
        } else {
          this.setState({dsProcesso: ''});
          this.setState({exibePesquisa: 'none'});
          this.setState({partes: null});
        }
        this.setState({situacao: response.data.situacao});
        this.listarArquivos(lancamento.codigo);
        this.abrirModaConsultaLancamanto('modalConsulta');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Consulta de Lancamento', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  renderFooterConsultaLancamento(name) {
    return (
        <div className="right">
            <Button label="Reabrir" 
                    className="p-button-info p-button-text" 
                    onClick={this.reabrirLancamento}/>
            &nbsp;
            <Button label="Pagar" 
                    className="p-button-success p-button-text"
                    onClick={this.consultarLancamentoPagamento}/>
            &nbsp;
            <Button label="Fechar" 
                    className="p-button-secondary p-button-text"
                    onClick={() => this.fecharModal(name)}/>
        </div>
    );
  }

  abrirModaConsultaLancamanto(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  limparCamposCadastro = () => {
    //this.state({selectCategoria: null});
    this.setState({tipo: null});
    this.setState({tipos: null});
    this.setState({vlLancamento: ''});
    this.setState({dtVencimento: ''});
    this.setState({processo: null});
    this.setState({dsProcesso: ''});
    this.setState({dsLancamento: ''});
    this.setState({observacao: ''});
    this.setState({optionRecorrencia: null});
    this.setState({selectCategoria: null});
    this.setState({parcelas: ''});
    this.setState({exibeProcessoPesquisado: 'none'});
    this.setState({exibePesquisa: 'block'});
    this.setState({atividade: []});
  }

  cadastrarLancamento = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    if(this.state.selectCategoria == null) {
      this.toast.show({severity:'error', summary: 'Cadastro de Lancamento', detail:'Informe a Categoria', life: 4000});
      return false;
    }

    if(this.state.tipo == null) {
      this.toast.show({severity:'error', summary: 'Cadastro de Lancamento', detail:'Inform o tipo de Despesa ou Receita', life: 4000});
      return false;
    }

    if(this.state.vlLancamento == '') {
      this.toast.show({severity:'error', summary: 'Cadastro de Lancamento', detail:'Inform o Valor', life: 4000});
      return false;
    }

    if(this.state.dtVencimento == '') {
      this.toast.show({severity:'error', summary: 'Cadastro de Lancamento', detail:'Informe a data de vencimento', life: 4000});
      return false;
    }

    if(this.state.optionRecorrencia != null && this.state.optionRecorrencia.codigo != 'S') {
      if(this.state.parcelas == '' || this.state.parcelas == '0') {
        this.toast.show({severity:'error', summary: 'Cadastro de Lancamento', detail:'Informe o número de parcelas', life: 4000});
        return false;
      }
    }
  
    //Data de vencimento
    var dataFormatadaDataVencimento = '';
    if(this.state.dtVencimento != '') {
      var date = this.state.dtVencimento;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      dataFormatadaDataVencimento =  year+"-"+month+"-"+day;
    }

    var criaAtividade = 'N';
    if(this.state.atividade.length > 0) {
      criaAtividade = 'S';
    } else {
      criaAtividade = 'N';
    }

    if(this.state.optionRecorrencia == null || this.state.optionRecorrencia.codigo == 'S') {
      this.setState({openSpinner: true});
      await this.financeiroService.cadastrarLancamento({
        tipo: this.state.tipo,
        usuario: usuarioLogado,
        vlLancamento: this.state.vlLancamento,
        dtVencimento: dataFormatadaDataVencimento,
        dsLancamento: this.state.dsLancamento,
        observacao: this.state.observacao,
        processo: this.state.processo,
        criaAtividade: criaAtividade
      }).then(response => {
        this.toast.show({severity:'success', summary: 'Novo Lançamento', detail:'Lançamento cadastrado com sucesso', life: 4000});
        this.consultaUnica();
        this.consultarDespesasxReceitas(usuarioLogado.empresa.codigo);
        this.fecharModal('modalCadastro');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Novo Lançamento', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
    } else {
      this.setState({openSpinner: true});
      await this.financeiroService.cadastrarLancamentoParcelas(this.state.parcelas, this.state.optionRecorrencia.codigo,{
        tipo: this.state.tipo,
        usuario: usuarioLogado,
        vlLancamento: this.state.vlLancamento,
        dtVencimento: dataFormatadaDataVencimento,
        dsLancamento: this.state.dsLancamento,
        observacao: this.state.observacao,
        processo: this.state.processo,
        criaAtividade: criaAtividade
      }).then(response => {
        this.toast.show({severity:'success', summary: 'Novo Lançamento', detail:'Lançamento cadastrado com sucesso', life: 4000});
        this.consultaUnica();
        this.consultarDespesasxReceitas(usuarioLogado.empresa.codigo);
        this.fecharModal('modalCadastro');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Novo Lançamento', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
    }
  }

  async componentDidMount() {
    this.setState({openSpinner: true});

    await this.listarMeses();
    const usuarioLogado = this.context.usuarioAutenticado;
    
    await this.consultarDespesasxReceitas(usuarioLogado.empresa.codigo);

    var data = new Date();
    var dia = String(data.getDate()). padStart(2, '0');
    var mes = String(data.getMonth() + 1). padStart(2, '0');
    var ano = data. getFullYear();
    var dataInicial = ano + '-' + mes + '-01';
    var dataFinal = ano + '-' + mes + '-' + '30';

    var dataInicial2 = new Date(dataInicial);
    dataInicial2.setDate(dataInicial2.getDate()+1)

    var dataFinal2 = new Date(dataFinal);
    dataFinal2.setDate(dataFinal2.getDate()+1)

    await this.setState({dataInicial: dataInicial2});
    await this.setState({dataFinal: dataFinal2});

    //this.consultarGraficosDespesas(dataInicial,dataFinal);
    //this.consultarGraficosReceitas(dataInicial,dataFinal)
    await this.consultaUnica();

    this.setState({openSpinner: false});
  }

  async abrirModalDespesas(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState({openSpinner: true});
    await this.listarTiposDespesas();
    this.setState({tipo: null});
    this.setState({optionSituacao: null});
    await this.consultarDespesasFiltro();
    this.setState({openSpinner: false});
    this.setState(state);
  }

  abrirModalReceitas(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.listarTiposReceitas();
    this.consultarReceitasFiltro();
    this.setState(state);
  }

  async abrirModaCadastro(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    await this.excluirArquivosTemp();
    await this.limparCamposCadastro();
    this.setState(state);
  }

  fecharModal(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  situacaoDespesa(rowData) {
    if(rowData.situacao == 'A') {
      return(
        <React.Fragment>
          <Tag className="p-mr-2"  severity="info" value="Ativo"></Tag>
        </React.Fragment>
      )
    } else if(rowData.situacao == 'C') {
      return(
        <React.Fragment>
          <Tag severity="danger" value="Cancelado"></Tag>
        </React.Fragment>
      )
    } else {
      return(
        <React.Fragment>
          <Tag className="mr-2" severity="success" value="Pago"></Tag>
        </React.Fragment>
      )
    }
  }

  acoesDespesas(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-search-plus" className="p-button-rounded p-button-text" 
                tooltip="Consultar"
                onClick={() => this.consultarLancamento(rowData)}
                tooltipOptions={{position: 'top'}} />
      </React.Fragment>
    );
  }

  renderFooterCadastro(name) {
    return (
        <div>
            <Button label="Cadastrar" 
                    className="p-button-primary p-button-text"
                    onClick={this.cadastrarLancamento}/>
            &nbsp;
            <Button label="Cancelar" 
                    className="p-button-secondary p-button-text"
                    onClick={() => this.fecharModal(name)}/>

        </div>
    );
  }

  onCriarAtividade(e) {
    let selectedCriaAtividade = [...this.state.atividade];

    if (e.checked)
      selectedCriaAtividade.push(e.value);
    else
      selectedCriaAtividade.splice(selectedCriaAtividade.indexOf(e.value), 1);

    this.setState({ atividade: selectedCriaAtividade });
  }

  getLightTheme() {
    let basicOptions = {
        maintainAspectRatio: false,
        aspectRatio: .8,
        plugins: {
            legend: {
                labels: {
                    color: '#495057'
                }
            }
        },
        scales: {
            x: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            }
        }
    };

    let horizontalOptions = {
        indexAxis: 'y',
        maintainAspectRatio: false,
        aspectRatio: .8,
        plugins: {
            legend: {
                labels: {
                    color: '#495057'
                }
            }
        },
        scales: {
            x: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            }
        }
    };

    let stackedOptions = {
        maintainAspectRatio: false,
        aspectRatio: .8,
        plugins: {
            tooltips: {
                mode: 'index',
                intersect: false
            },
            legend: {
                labels: {
                    color: '#495057'
                }
            }
        },
        scales: {
            x: {
                stacked: true,
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y: {
                stacked: true,
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            }
        }
    };

    let multiAxisOptions = {
        maintainAspectRatio: false,
        aspectRatio: .8,
        plugins: {
            legend: {
                labels: {
                    color: '#495057'
                }
            },
            tooltips: {
                mode: 'index',
                intersect: true
            }
        },
        scales: {
            x: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y: {
                type: 'linear',
                display: true,
                position: 'left',
                ticks: {
                    min: 0,
                    max: 100,
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y1: {
                type: 'linear',
                display: true,
                position: 'right',
                grid: {
                    drawOnChartArea: false,
                    color: '#ebedef'
                },
                ticks: {
                    min: 0,
                    max: 100,
                    color: '#495057'
                }
            }
        }
    };

    return {
        basicOptions,
        horizontalOptions,
        stackedOptions,
        multiAxisOptions
    }
  }
  
  //Cancelar Despesas em Massa
  cancelarLancamentosDespesasMassa =() => {
    if(this.state.selectDespesas == null || this.state.selectDespesas.length == 0) {
      this.toast.show({severity:'error', summary: 'Cancelamento de Lançamentos', detail:'Nenhum lançamento selecionado', life: 4000});
      return false;
    }

    for(let i = 0; i < this.state.selectDespesas.length; i++) {
      this.financeiroService.pagarOuCancelarLancamento({
        codigo: this.state.selectDespesas[i].codigo,
        situacao: 'C'
      }).then(response => {
        this.toast.show({severity:'success', summary: 'Cancelamento de Lançamentos', detail:'Lançamento Cancelado', life: 4000});
        this.consultarDespesasFiltro();
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Cancelamento de Lançamentos', detail:`${this.state.detail}`, life: 4000});
      })
    }
  }

  acceptCancelarMassaDespesas() {
    this.cancelarLancamentosDespesasMassa();
  }

  confirmaCancelamentoMassaDespesas = () => {
      confirmDialog({
          message: 'Deseja realmente cancelar os lançamentos selecionados ?',
          header: 'Cancelar Lançamentos',
          icon: 'pi pi-info-circle',
          acceptClassName: 'p-button-danger',
          acceptLabel: 'Sim',
          rejectLabel: 'Não',
          accept: this.acceptCancelarMassaDespesas,
          reject: this.reject
      });
  }

  renderDespesas() {
    return (
      <div>
          <Button label="Cancelar Lançamento" 
                  className="p-button-danger p-button-text" 
                  onClick={this.confirmaCancelamentoMassaDespesas}/>
          &nbsp;
          <Button label="Fechar" 
                  className="p-button-secondary p-button-text"
                  onClick={() => this.fecharModal('modalDespesa')}/>
      </div>
    );
  }

  //Cancelar Receitas em Massa
  cancelarLancamentosReceitasMassa =() => {
    if(this.state.selectReceitas == null || this.state.selectReceitas.length == 0) {
      this.toast.show({severity:'error', summary: 'Cancelamento de Lançamentos', detail:'Nenhum lançamento selecionado', life: 4000});
      return false;
    }

    for(let i = 0; i < this.state.selectReceitas.length; i++) {
      this.financeiroService.pagarOuCancelarLancamento({
        codigo: this.state.selectReceitas[i].codigo,
        situacao: 'C'
      }).then(response => {
        this.toast.show({severity:'success', summary: 'Cancelamento de Lançamentos', detail:'Lançamento Cancelado', life: 4000});
        this.consultarDespesasFiltro();
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Cancelamento de Lançamentos', detail:`${this.state.detail}`, life: 4000});
      })
    }
  }

  acceptCancelarMassaReceitas() {
    this.cancelarLancamentosReceitasMassa();
  }

  confirmaCancelamentoMassaReceitas = () => {
      confirmDialog({
          message: 'Deseja realmente cancelar os lançamentos selecionados ?',
          header: 'Cancelar Lançamentos',
          icon: 'pi pi-info-circle',
          acceptClassName: 'p-button-danger',
          acceptLabel: 'Sim',
          rejectLabel: 'Não',
          accept: this.acceptCancelarMassaReceitas,
          reject: this.reject
      });
  }

  renderReceitas() {
    return (
      <div>
          <Button label="Cancelar Lançamento" 
                  className="p-button-danger p-button-text" 
                  onClick={this.confirmaCancelamentoMassaReceitas}/>
          &nbsp;
          <Button label="Fechar" 
                  className="p-button-secondary p-button-text"
                  onClick={() => this.fecharModal('modalReceitas')}/>

      </div>
    );
  }

  //Pagamentos
  consultarLancamentoPagamento = () => {
    if(this.state.lancamento.situacao == 'Pago') {
      this.toast.show({severity:'error', summary: 'Lançamento', detail:'Este Lançamento já encontra-se pago', life: 5000});
      return;
    }

    this.setState({vlLancamentoNovo: ''});
    this.setState({dtVencimentoNovo: ''});
    this.setState({contaFinanceira: null});
    this.setState({observacao: ''});
    this.listarContasFinanceiras();
    if(this.state.lancamento.tipo.tipo == 'D') {
      this.abrirModal('modalDespesaPagamento')
    } else {
      this.abrirModal('modalReceitaPagamento')
    }
  }

  abrirModal(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  //Pagar Despesa e Receita
  pagarDespesaReceita = async () => {
    const usuarioLogado = this.context.usuarioAutenticado

    if(this.state.lancamento.situacao == 'Pago') {
      this.toast.show({severity:'error', summary: 'Pagamento', detail:'Lançamento já está pago', life: 4000});
      return false;
    }

    if(this.state.contaFinanceira == null) {
      this.toast.show({severity:'error', summary: 'Pagamento', detail:'Informe a conta para pagamento', life: 4000});
      return false;
    }

    //Se o campo de novo valor estiver preenchido, paga o novo valor e cria um novo lancamento com a diferença
    if(this.state.vlLancamentoNovo != '' && this.state.vlLancamentoNovo != null) {
      //Efetua pagamento
      if(this.state.dtVencimentoNovo == '') {
        this.toast.show({severity:'error', summary: 'Pagamento', detail:'Informe a data de Vencimento', life: 4000});
        return false;
      }

      this.setState({openSpinner: true});
      await this.financeiroService.pagarOuCancelarLancamentoIndividual({
        codigo: this.state.lancamento.codigo,
        situacao: 'P',
        vlPago: this.state.vlLancamentoNovo,
        observacao: this.state.observacao,
        conta: this.state.contaFinanceira
      }).then(response => {
        this.toast.show({severity:'success', summary: 'Pagamento', detail:'Pagamento Efetuado', life: 4000});
        //Aqui regra de fechar o modal
        if(this.state.lancamento.tipo.tipo == 'D') {
          this.fecharModal('modalDespesaPagamento');
          this.consultarDespesasFiltro();
        } else {
          this.fecharModal('modalReceitaPagamento');
          this.consultarReceitasFiltro();
        }
        this.this.consultaUnica();
        this.fecharModal('modalConsulta');
      }).catch(error => {
        this.setState({openSpinner: false});
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Pagamento', detail:`${this.state.detail}`, life: 4000});
      });

      //Data de vencimento
      var novoValor = this.state.vlLancamentoSemMascara - this.state.vlLancamentoNovo;
      var dataFormatadaDataVencimento = '';
      if(this.state.dtVencimentoNovo != '') {
        var date = this.state.dtVencimentoNovo;
        var month = this.pad2(date.getMonth()+1);//months (0-11)
        var day = this.pad2(date.getDate());//day (1-31)
        var year= date.getFullYear();
        dataFormatadaDataVencimento =  year+"-"+month+"-"+day;
      };

      this.financeiroService.cadastrarLancamento({
        tipo: this.state.tipo,
        vlLancamento: novoValor,
        dtVencimento: dataFormatadaDataVencimento,
        observacao: `Difereça do pagamento anterior, lançamento número: ${this.state.codigoLancamento}`,
        situacao: 'A',
        usuario: usuarioLogado.codigo,
        vlPago: '0',
        processo: this.state.lancamento.processo
      }).then(response => {
        this.toast.show({severity:'success', summary: 'Cadastro de Lançamento', detail:'Novo lançamento cadastrado', life: 4000});
      }).catch(error => {
        this.setState({openSpinner: false});
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Cadastro de Lançamento', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
    } else {
      //Paga o valor total
      this.setState({openSpinner: true});
      await this.financeiroService.pagarOuCancelarLancamentoIndividual({
        codigo: this.state.lancamento.codigo,
        situacao: 'P',
        vlPago: this.state.vlLancamentoSemMascara,
        observacao: this.state.observacao,
        conta: this.state.contaFinanceira
      }).then(response => {
        this.toast.show({severity:'success', summary: 'Pagamento', detail:'Pagamento Efetuado', life: 4000});
        //Aqui regra de fechar o modal
        if(this.state.lancamento.tipo.tipo == 'D') {
          this.fecharModal('modalDespesaPagamento');
          this.consultarDespesasFiltro();
        } else {
          this.fecharModal('modalReceitaPagamento');
          this.consultarReceitasFiltro();
        }
        this.fecharModal('modalConsulta');
      }).catch(error => {
        this.setState({openSpinner: false});
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Pagamento', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
    }
  }

  reabrirLancamento = () => {
    if(this.state.lancamento.situacao == 'Ativo') {
      this.toast.show({severity:'error', summary: 'Pagamento', detail:'O lançamento está ativo', life: 4000});
      return false;
    }
    this.financeiroService.reabrirLancamento({
      codigo: this.state.lancamento.codigo,
      situacao: 'A',
      conta: this.state.contaFinanceira
    }).then(response => {
      this.toast.show({severity:'success', summary: 'Pagamento', detail:'Lançamento Reaberto', life: 4000});
      this.fecharModal('modalConsulta');
      this.consultarDespesasFiltro();
    }).catch(error => {
      this.setState(error.response.data);
      this.toast.show({severity:'error', summary: 'Pagamento', detail:`${this.state.detail}`, life: 4000});
    })
  }
  
  render() {

    const { upLoadFiles } = this.state;
    const { basicOptions, horizontalOptions, multiAxisOptions, stackedOptions } = this.options;

    return(
      <>
        <NavBar/>
        <Toast ref={(el) => this.toast = el} />
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
            <div className="row">
                <div className="col-md-12">
                  <div className="card card-primary card-outline">
                    <div className="card-header">
                      <h3 className="card-title">
                        <i className="fas fa-hand-holding-usd"></i>
                        <span> Painel Financeiro</span>
                      </h3>  

                      <div style={{textAlign: 'right'}}>

                          <Button className="p-button-primary p-button-text p-button-sm" 
                                  onClick={() => this.abrirModaCadastro('modalCadastro')}
                                  data-toggle="modal" 
                                  style={{height: '32px'}} 
                                  data-target="#modal-default">
                          <i className="fas fa-plus"></i>&nbsp;Novo Lançamento</Button>
                          &nbsp;
                          &nbsp;
                          <Calendar id="mask" 
                                    value={this.state.dataInicial} 
                                    onChange={(e) => this.setState({ dataInicial: e.value })} 
                                    locale="es"
                                    style={{height: '32px', width: '135px'}} 
                                    dateFormat="dd/mm/yy"
                                    mask="99/99/9999"/>
                          &nbsp;
                          <Calendar id="mask" 
                                    value={this.state.dataFinal} 
                                    onChange={(e) => this.setState({ dataFinal: e.value })} 
                                    locale="es"
                                    style={{height: '32px', width: '135px'}} 
                                    dateFormat="dd/mm/yy"
                                    mask="99/99/9999"/>
                        
                        &nbsp;&nbsp;
                        <Button style={{height: '32px'}} type="button" className="p-button-secondary p-button-text p-button-sm" 
                                onClick={this.consultaUnica}>
                            <i className="pi pi-filter"></i> Mudar Período</Button>
                    </div>
                  </div>
                    
                    <Backdrop
                      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                      open={this.state.openSpinner}>
                      <CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
                    </Backdrop>

                    <div className="card-body">
                      <Progresso classeSecundaria={this.state.classeDiv}/>
                      <div className="row">
                        <div className="col-sm-2">
                          <div className="formGroup">
                            <a href className="cursor" onClick={() => this.abrirModalDespesas('modalDespesa')}
                                                       data-toggle="modal" 
                                                       data-target="#modal-default">
                              <div className="cardDespesa blue">
                                <h4 className="textoCard">Despesas</h4>
                                <br></br>
                                <p>{this.state.despesaTotal}</p>
                              </div>
                            </a>
                          </div>
                        </div>
                        <div className="col-sm-2">
                          <div className="formGroup">
                            <a href className="cursor" onClick={() => this.abrirModalReceitas('modalReceitas')}
                                                      data-toggle="modal" 
                                                      data-target="#modal-default">
                                <div className="cardReceita blue">
                                  <h4 className="textoCard">Receitas</h4>
                                  <br></br>
                                  <p>{this.state.receitaTotal}</p>
                              </div>
                            </a>  
                          </div>
                        </div>
                        <div className="col-sm-2">
                          <div className="formGroup">
                            <div className="cardVencendoAmanha blue">
                              <h4 className="textoCard">Vencd. Amanh.</h4>
                              <br></br>
                              <p>{this.state.vencendoAmanha}</p>
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-2">
                          <div className="formGroup">
                            <a href className="cursor" onClick={() => this.abrirModalVencendoHoje('modalVencendoHoje')}
                                                      data-toggle="modal" 
                                                      data-target="#modal-default">
                              <div className="cardVencendoHoje blue">
                                <h4 className="textoCard">Vencd. Hoje</h4>
                                <br></br>
                                <p>{this.state.vencendoHoje}</p>
                              </div>
                            </a>
                          </div>
                        </div>
                        <div className="col-sm-2">
                          <div className="formGroup">
                            <a href className="cursor" onClick={() => this.abrirModalPendentes('modalPendentes')}
                                                        data-toggle="modal" 
                                                        data-target="#modal-default">
                                <div className="cardPendente blue">
                                  <h4 className="textoCard">Pendente</h4>
                                  <br></br>
                                  <p>{this.state.pendente}</p>
                                </div>
                            </a>
                          </div>
                        </div>
                        <div className="col-sm-2">
                          <div className="formGroup">
                            <div className="cardSaldo blue">
                              <h4 className="textoCard">Saldo</h4>
                              <br></br>
                              <p>{this.state.saldo}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="formGroup">
                          <div className="card flex justify-content-center">
                              <h5>Despesas x Receitas</h5>
                              <Chart type="bar" data={this.state.basicData2} options={basicOptions} />
                          </div>  
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="formGroup">
                          <div className="card flex justify-content-center" style={{alignItems: 'center'}}>
                              <h5>Despesas por Tipo</h5>
                              <Chart type="pie" data={this.state.pieDespesas} style={{ position: 'relative', width: '48%' }} />
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="formGroup">
                          <div className="card flex justify-content-center" style={{alignItems: 'center'}}>
                              <h5>Receitas por Tipo</h5>
                              <Chart type="pie" data={this.state.pieReceitas} style={{ position: 'relative', width: '48%' }} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/**Despesas Detalhadas */}
            <Dialog header="Despesas Detalhadas"
                      visible={this.state.modalDespesa} 
                      footer={this.renderDespesas} 
                      style={{ width: '60vw' }}
                      onHide={() => this.fecharModal('modalDespesa')}>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="formGroup">
                    <label>Tipos de Despesas</label>
                    <Dropdown value={this.state.tipo} style={{width: '100%', height: '32px'}}  
                              options={this.state.tipos} style={{width: '100%', height: '32px'}} 
                              optionLabel="nome" 
                              filter showClear filterBy="nome"
                              emptyMessage=" "
                              onChange={this.onDespesaChange}
                              id="tipoDespesa"
                              className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <div className="formGroup">
                      <label>Situação</label>
                      <Dropdown value={this.state.optionSituacao} style={{width: '100%', height: '32px'}} 
                                options={this.statusSituacao} style={{width: '100%', height: '32px'}}
                                optionLabel="nome" 
                                emptyMessage=" "
                                filter showClear filterBy="nome"
                                onChange={this.onChangeOptionSituacao}
                                id="idSituacao"
                                className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                  </div>
                  <div className="col-sm-2">
                    <div className="formGroup">
                       <label>&nbsp;</label>
                       <Button className="p-button-info p-button-text p-button-sm" onClick={this.filtrarTipoDespesaPeriodo}>
                        <i className="pi pi-filter"></i>&nbsp;&nbsp;Filtrar</Button>
                    </div>
                  </div>
               </div>
               <br></br>
               <div className="row">
                  <div className="col-sm-6">
                    <div className="formGroup">
                        <span className="verde">Pagos: {this.state.totalPagoDespesa}</span>&nbsp;&nbsp;
                        <span className="vermelho">Ativos: {this.state.totalAtivoDespesa}</span>&nbsp;&nbsp;
                        <span className="cinza">Total: {this.state.totalPagosAtivos}</span>
                    </div>
                  </div>
                </div>
                <br></br>
               <DataTable value={this.state.despesasPeriodo}  paginator responsiveLayout="scroll"
                          selection={this.state.selectDespesas} onSelectionChange={(e) => this.setState({ selectDespesas: e.value })}
                          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                          currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" emptyMessage="Nenhum Tipo de Despesa ou receita cadastrados" rows={5}>
                          <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} exportable={false}></Column>
                          <Column field="tipo.nome" header="Despesa"></Column>
                          <Column field="valorLancamentoFormat" header="Valor"></Column>
                          <Column field="dtVencimento" header="Vencimento"></Column>
                          <Column field="valorPagamentoFormat" header="Vl Pago"></Column>
                          <Column body={this.situacaoDespesa} exportable={false} style={{ minWidth: '8rem' }} header="Situação"/>
                          <Column body={this.acoesDespesas} exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
               </DataTable>
            </Dialog>

            {/**Pagar outro valor despesa*/}
            <Dialog header="Pagamento de Despesas"
                      visible={this.state.modalDespesaPagamento} 
                      style={{ width: '50vw' }}
                      footer={
                        <div alignItems="right">
                          <Button label="Pagar Lançamento" 
                                  className="p-button-success p-button-text"
                                  onClick={this.pagarDespesaReceita}/>
                          &nbsp;
                          <Button label="Fechar" 
                                  className="p-button-secondary p-button-text"
                                  onClick={() => this.fecharModal('modalDespesaPagamento')}/>
                        </div>
                      }
                      onHide={() => this.fecharModal('modalDespesaPagamento')}>
              <div className="row">
                <div className="col-sm-12">
                  <div className="formGroup">
                    <label>Despesa</label>
                    <InputText id="tipoNomePagamento" 
                               type="text" 
                               style={{width: '100%', height: '32px'}} 
                               value={this.state.tipoNome}
                               disabled="true"
                               className="p-inputtext-sm p-d-block p-mb-1"/>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <div className="formGroup">
                    <label>Valor</label>
                    <InputText id="valorPagamento" 
                               type="text" 
                               style={{width: '100%', height: '32px'}} 
                               value={this.state.vlLancamento}
                               disabled="true"
                               className="p-inputtext-sm p-d-block p-mb-1"/>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="formGroup">
                    <label>Vencimento</label>
                    <InputText id="vencimentoPagamento" 
                               type="text" 
                               style={{width: '100%', height: '32px'}} 
                               value={this.state.dtVencimento}
                               disabled="true"
                               className="p-inputtext-sm p-d-block p-mb-1"/>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <div className="formGroup">
                    <label>Pagar um novo valor</label>
                    <InputNumber inputId="pagamentoNovoValorDespesa" 
                                 value={this.state.vlLancamentoNovo} 
                                 style={{width: '100%', height: '32px'}} 
                                 onChange={(e) => this.setState({vlLancamentoNovo: e.value})} 
                                 mode="decimal" locale="de-BR" minFractionDigits={2}/>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="formGroup">
                    <label>Novo Vencimento saldo devedor</label>
                    <Calendar id="novoVencimentoDespesa" 
                              value={this.state.dtVencimentoNovo} 
                              onChange={(e) => this.setState({ dtVencimentoNovo: e.value })} 
                              locale="es"
                              style={{width: '100%', height: '32px'}} 
                              dateFormat="dd/mm/yy"
                              mask="99/99/9999"/>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="formGroup">
                    <label>Observação</label>
                    <InputTextarea id="observacaoPagamento" 
                                   type="text" 
                                   style={{width: '100%'}} 
                                   value={this.state.observacao}
                                   onChange={e => this.setState({observacao: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"
                                   rows={2} cols={30}/>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="formGroup">
                    <label>Conta para pagamento</label>
                    <Dropdown value={this.state.contaFinanceira} style={{width: '100%', height: '32px'}} 
                              options={this.state.contasFinanceiras} 
                              style={{width: '100%', height: '32px'}}
                              optionLabel="nomeFormat" 
                              emptyMessage=" "
                              filter showClear filterBy="nome"
                              onChange={e => this.setState({contaFinanceira: e.value})}
                              id="contaFinanceira"
                              className="p-inputtext-sm p-d-block p-mb-1"/>
                  </div>
                </div>
              </div>
            </Dialog>

            {/**Pagar outro valor receita*/}
            <Dialog header="Pagamento de Receitas"
                      visible={this.state.modalReceitaPagamento} 
                      style={{ width: '50vw' }}
                      footer={
                        <div alignItems="right">
                          <Button label="Pagar Lançamento" 
                                  className="p-button-success p-button-text"
                                  onClick={this.pagarDespesaReceita}/>
                          &nbsp;
                          <Button label="Fechar" 
                                  className="p-button-secondary p-button-text"
                                  onClick={() => this.fecharModal('modalReceitaPagamento')}/>
                        </div>
                      }
                      onHide={() => this.fecharModal('modalReceitaPagamento')}>
              <div className="row">
                <div className="col-sm-12">
                  <div className="formGroup">
                    <label>Receita</label>
                    <InputText id="tipoNomePagamento" 
                               type="text" 
                               style={{width: '100%', height: '32px'}} 
                               value={this.state.tipoNome}
                               disabled="true"
                               className="p-inputtext-sm p-d-block p-mb-1"/>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <div className="formGroup">
                    <label>Valor</label>
                    <InputText id="valorPagamento" 
                               type="text" 
                               style={{width: '100%', height: '32px'}} 
                               value={this.state.vlLancamento}
                               disabled="true"
                               className="p-inputtext-sm p-d-block p-mb-1"/>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="formGroup">
                    <label>Vencimento</label>
                    <InputText id="vencimentoPagamento" 
                               type="text" 
                               style={{width: '100%', height: '32px'}} 
                               value={this.state.dtVencimento}
                               disabled="true"
                               className="p-inputtext-sm p-d-block p-mb-1"/>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <div className="formGroup">
                    <label>Pagar um novo valor</label>
                    <InputNumber inputId="pagamentoNovoValorDespesa" 
                                 value={this.state.vlLancamentoNovo} 
                                 style={{width: '100%', height: '32px'}} 
                                 onChange={(e) => this.setState({vlLancamentoNovo: e.value})} 
                                 mode="decimal" locale="de-BR" minFractionDigits={2}/>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="formGroup">
                    <label>Novo Vencimento saldo devedor</label>
                    <Calendar id="novoVencimentoDespesa" 
                              value={this.state.dtVencimentoNovo} 
                              onChange={(e) => this.setState({ dtVencimentoNovo: e.value })} 
                              locale="es"
                              style={{width: '100%', height: '32px'}} 
                              dateFormat="dd/mm/yy"
                              mask="99/99/9999"/>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="formGroup">
                    <label>Observação</label>
                    <InputTextarea id="observacaoPagamento" 
                                   type="text" 
                                   style={{width: '100%'}} 
                                   value={this.state.observacao}
                                   onChange={e => this.setState({observacao: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"
                                   rows={2} cols={30}/>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="formGroup">
                    <label>Conta para pagamento</label>
                    <Dropdown value={this.state.contaFinanceira} style={{width: '100%', height: '32px'}} 
                              options={this.state.contasFinanceiras} 
                              style={{width: '100%', height: '32px'}}
                              optionLabel="nomeFormat" 
                              emptyMessage=" "
                              filter showClear filterBy="nome"
                              onChange={e => this.setState({contaFinanceira: e.value})}
                              id="contaFinanceira"
                              className="p-inputtext-sm p-d-block p-mb-1"/>
                  </div>
                </div>
              </div>
            </Dialog>

            {/**Receitas Detalhadas */}
            <Dialog header="Receitas Detalhadas"
                      visible={this.state.modalReceitas} 
                      style={{ width: '60vw' }}
                      footer={this.renderReceitas}
                      onHide={() => this.fecharModal('modalReceitas')}>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="formGroup">
                      <label>Tipos de Receitas</label>
                      <Dropdown value={this.state.tipo} style={{width: '100%', height: '32px'}}  
                                options={this.state.tipos} style={{width: '100%', height: '32px'}} 
                                optionLabel="nome" 
                                filter showClear filterBy="nome"
                                emptyMessage=" "
                                onChange={this.onDespesaChange}
                                id="tipoDespesa"
                                className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <div className="formGroup">
                      <label>Situação</label>
                      <Dropdown value={this.state.optionSituacao} style={{width: '100%', height: '32px'}} 
                                options={this.statusSituacao} style={{width: '100%', height: '32px'}}
                                optionLabel="nome" 
                                emptyMessage=" "
                                filter showClear filterBy="nome"
                                onChange={this.onChangeOptionSituacao}
                                id="idSituacao"
                                className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                  </div>
                  <div className="col-sm-2">
                    <div className="formGroup">
                       <label>&nbsp;</label>
                       <Button className="p-button-info p-button-text p-button-sm" onClick={this.filtrarTipoReceitasPeriodo}>
                        <i className="pi pi-filter"></i>&nbsp;&nbsp;Filtrar</Button>
                    </div>
                  </div>
               </div>
               <br></br>
               <div className="row">
                  <div className="col-sm-6">
                    <div className="formGroup">
                        <span className="verde">Pagos: {this.state.totalPagoDespesa}</span>&nbsp;&nbsp;
                        <span className="vermelho">Ativos: {this.state.totalAtivoDespesa}</span>&nbsp;&nbsp;
                        <span className="cinza">Total: {this.state.totalPagosAtivos}</span>
                    </div>
                  </div>
                </div>
                <br></br>
               <DataTable value={this.state.receitasPeriodo}  paginator responsiveLayout="scroll"
                          size="small"
                          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                          selection={this.state.selectReceitas} onSelectionChange={(e) => this.setState({ selectReceitas: e.value })}
                          currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" emptyMessage="Nenhum Tipo de Despesa ou receita cadastrados" rows={5}>
                          <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} exportable={false}></Column>
                          <Column field="tipo.nome" header="Despesa"></Column>
                          <Column field="valorLancamentoFormat" header="Valor"></Column>
                          <Column field="dtVencimento" header="Vencimento"></Column>
                          <Column field="valorPagamentoFormat" header="Vl Pago"></Column>
                          <Column body={this.situacaoDespesa} exportable={false} style={{ minWidth: '8rem' }} header="Situação"/>
                          <Column body={this.acoesDespesas} exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
               </DataTable>
            </Dialog>

            {/**Novo Lancamento */}
            <Dialog header="Cadastrar Lançamento"
                      visible={this.state.modalCadastro} 
                      style={{ width: '50vw' }}  
                      footer={this.renderFooterCadastro('modalCadastro')} 
                      onHide={() => this.fecharModal('modalCadastro')}>
                <TabView activeIndex={this.state.tabAtivo}>
                  <TabPanel header="Lançamento">
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="formGroup">
                          <label>Categoria <span className="obrigatorioAsterisco"> *</span></label>
                          <Dropdown value={this.state.selectCategoria} style={{width: '100%', height: '32px'}} 
                                    options={this.categoria} style={{width: '100%', height: '32px'}}
                                    optionLabel="nome" 
                                    emptyMessage=" "
                                    onChange={this.onChangeCategoria}
                                    id="idCategoria"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="formGroup">
                          <label>Tipo <span className="obrigatorioAsterisco"> *</span></label>
                          <Dropdown value={this.state.tipo} 
                                    options={this.state.tipos} style={{width: '100%', height: '32px'}}
                                    optionLabel="nome" 
                                    emptyMessage=" "
                                    filter showClear filterBy="nome"
                                    onChange={this.onDespesaChange}
                                    id="tipoDespesa"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="formGroup">
                          <label>Valor <span className="obrigatorioAsterisco"> *</span></label>
                          <InputNumber inputId="locale-german" 
                                      value={this.state.vlLancamento} 
                                      style={{width: '100%', height: '32px'}} 
                                      onChange={(e) => this.setState({vlLancamento: e.value})} 
                                      mode="decimal" locale="de-BR" minFractionDigits={2}/>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="formGroup">
                          <label>Vencimento <span className="obrigatorioAsterisco"> *</span></label>
                          <Calendar id="mask" 
                                    value={this.state.dtVencimento} 
                                    onChange={(e) => this.setState({ dtVencimento: e.value })} 
                                    locale="es"
                                    style={{width: '100%', height: '32px'}} 
                                    dateFormat="dd/mm/yy"
                                    mask="99/99/9999"/>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="formGroup">
                          <label>Recorrêcnia <span className="obrigatorioAsterisco"> *</span></label>
                          <Dropdown value={this.state.optionRecorrencia} 
                                    options={this.recorrencia} style={{width: '100%'}}
                                    optionLabel="nome" 
                                    onChange={this.onOptionRecoorencia}
                                    id="recorrencia"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="formGroup">
                          <label>Parcelas</label>
                          <InputText id="parcelas" 
                                    type="text" 
                                    style={{width: '100%', height: '32px'}} 
                                    value={this.state.parcelas}
                                    onChange={e => this.setState({parcelas: e.target.value})}
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                    <div className="col-sm-12">
                      <div className="formGroup">
                        <label>Descrição</label>
                        <InputText id="dsLancamento" 
                                  type="text" 
                                  style={{width: '100%', height: '32px'}} 
                                  value={this.state.dsLancamento}
                                  onChange={e => this.setState({dsLancamento: e.target.value})}
                                  className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                  </div>
                  <div style={{display: `${this.state.exibePesquisa}`}}>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="formGroup">
                          <label>Processo</label>
                          <InputText id="processo" 
                                    type="text" 
                                    style={{width: '100%', height: '32px'}} 
                                    value={this.state.dsProcesso}
                                    onKeyPress={event => event.key === 'Enter' && this.consultarProcessoPorIndice()}
                                    onChange={e => this.setState({dsProcesso: e.target.value})}
                                    placeholder="Consulte um processo por número ou partes envolvidas"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style={{display: `${this.state.exibeProcessoPesquisado}`}}>
                    <br/>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="formGroup">
                          <strong>Processo: {this.state.dsProcesso}</strong>
                          <br/>
                          <a onClick={this.excluirPesquisaProcesso} className="linkCadGrupo" style={{cursor: 'pointer'}}>Desvincular Processo</a>
                        </div>
                      </div>
                    </div>
                    <br/>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="formGroup">
                          <DataTable value={this.state.partes} size="small" emptyMessage=" ">
                            <Column field="pessoa.nome" header="Parte"/>
                          </DataTable> 
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <label>Observação</label>
                        <InputTextarea id="pedidos" 
                                        type="text" 
                                        style={{width: '100%'}} 
                                        value={this.state.observacao}
                                        onChange={e => this.setState({observacao: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"
                                        rows={2} cols={30}/>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <Checkbox inputId="atividade" 
                                            name="atividade" 
                                            value="atividade" 
                                            onChange={this.onCriarAtividade} 
                                            checked={this.state.atividade.indexOf('atividade') !== -1} />
                        &nbsp;
                        Criar Atividade
                      </div>
                    </div>
                  </div>
                </TabPanel>
                <TabPanel header="Arquivos">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">  
                        <div className="container">
                          
                          <Upload onUpload={this.handleUploadTemp}/>
                          {!!upLoadFiles && (
                            <FileList files={upLoadFiles} onDelete={this.handleDelete}/>
                          )}
                        
                        </div>
                      </div>
                    </div>
                  </div>
                  <DataTable value={this.state.arquivosTemp} paginator responsiveLayout="scroll" size="small"
                              paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                              currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10}
                              emptyMessage="Nenhum Arquivo">
                    <Column field="arquivo" header="Arquivo"/>
                    <Column field="descricao" header="Descrição"/>
                    <Column body={this.acoesArquivosTemp} exportable={false} style={{ minWidth: '8rem' }} header="Ações"/>
                  </DataTable> 
                </TabPanel>
              </TabView>  
            </Dialog>
            {/**Pesquisa de Processos */}
            <Dialog header="Busca de Processo"
                    visible={this.state.modalProcesso} 
                    style={{ width: '60vw' }} 
                    footer={this.renderFooterProcesso('modalProcesso')} 
                    onHide={() => this.fecharModal('modalProcesso')}>    

                <DataTable value={this.state.processos}  alwaysShowPaginator responsiveLayout="scroll"
                          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                          currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={4} emptyMessage=" "
                          paginatorRight selectionMode="multiple">
                  <Column field="pasta" header="Pasta"></Column>
                  <Column field="nrProcesso" header="Processo Original"></Column>
                  <Column field="nrCnj" header="Numeração Única"></Column>
                  <Column field="autor" header="Autor x Réu" style={{width: '300px'}}></Column>
                  <Column field="grupoTrabalho.nome" header="Grupo Trab."></Column>
                  <Column body={this.acoesProcesso} exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
                </DataTable>
            </Dialog>

            {/**Consultar Lançamento */}
            <Dialog header={`Lançamento - [${this.state.codigoLancamento}]`}
                    visible={this.state.modalConsulta} 
                    style={{ width: '60vw' }} 
                    footer={this.renderFooterConsultaLancamento('modalConsulta')} 
                    onHide={() => this.fecharModal('modalConsulta')}>
              <TabView activeIndex={this.state.tabAtivo}>
                  <TabPanel header="Lançamento">
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="formGroup">
                          <label>Categoria</label>
                          <InputText id="categoriaConsulta" 
                                    type="text" 
                                    style={{width: '100%', height: '32px'}} 
                                    value={this.state.categoriaNome}
                                    disabled="true"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="formGroup">
                          <label>Tipo</label>
                          <InputText id="tipoNome" 
                                    type="text" 
                                    style={{width: '100%', height: '32px'}} 
                                    value={this.state.tipoNome}
                                    disabled="true"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="formGroup">
                          <label>Valor</label>
                          <InputText id="valorConsulta" 
                                    type="text" 
                                    style={{width: '100%', height: '32px'}} 
                                    value={this.state.vlLancamento}
                                    disabled="true"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="formGroup">
                          <label>Vencimento</label>
                          <InputText id="dataVencimentoConsulta" 
                                    type="text" 
                                    style={{width: '100%', height: '32px'}} 
                                    value={this.state.dtVencimento}
                                    disabled="true"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-4">
                        <div className="formGroup">
                          <label>Situação</label>
                          <InputText id="situacaoConsulta" 
                                    type="text" 
                                    style={{width: '100%', height: '32px'}} 
                                    value={this.state.situacao}
                                    disabled="true"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="formGroup">
                          <label>Valor Pago</label>
                          <InputText id="valorPago" 
                                    type="text" 
                                    style={{width: '100%', height: '32px'}} 
                                    value={this.state.vlPago}
                                    disabled="true"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="formGroup">
                          <label>Dt. Pagt.</label>
                          <InputText id="dataPagamento" 
                                    type="text" 
                                    style={{width: '100%', height: '32px'}} 
                                    value={this.state.dtPago}
                                    disabled="true"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                    </div>
                    <div style={{display: `${this.state.exibePesquisa}`}}>
                      <br/>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="formGroup">
                            <strong>Processo: <strong style={{color: '#5486F5'}}>{this.state.dsProcesso}</strong></strong>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="formGroup">
                            <DataTable value={this.state.partes} size="small" emptyMessage=" ">
                              <Column field="pessoa.nome" header="Parte"/>
                            </DataTable> 
                          </div>
                        </div>
                      </div>
                      <br/>
                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="formGroup">
                          <label>Descrição</label>
                          <InputText id="descricaoConsulta" 
                                    type="text" 
                                    style={{width: '100%', height: '32px'}} 
                                    value={this.state.dsLancamento}
                                    disabled="true"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="formGroup">
                          <label>Conta Financeira</label>
                          <InputText id="contaFinanceira" 
                                    type="text" 
                                    style={{width: '100%', height: '32px'}} 
                                    value={this.state.nomeConta}
                                    disabled="true"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="formGroup">
                          <label>Observação</label>
                          <InputTextarea id="observacao" 
                                        type="text" 
                                        style={{width: '100%'}} 
                                        value={this.state.observacao}
                                        disabled="true"
                                        className="p-inputtext-sm p-d-block p-mb-1"
                                        rows={2} cols={30}/>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel header="Arquivos">
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group">  
                          <div className="container">
                            
                            <Upload onUpload={this.handleUpload}/>
                            {!!upLoadFiles && (
                              <FileList files={upLoadFiles} onDelete={this.handleDelete}/>
                            )}
                          
                          </div>
                        </div>
                      </div>
                    </div>
                    <DataTable value={this.state.arquivos} paginator responsiveLayout="scroll" size="small"
                                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10}
                                emptyMessage="Nenhum Arquivo">
                      <Column field="arquivo" header="Arquivo"/>
                      <Column field="descricao" header="Descrição"/>
                      <Column body={this.acoesArquivos} exportable={false} style={{ minWidth: '8rem' }} header="Ações"/>
                    </DataTable> 
                  </TabPanel>
                </TabView>
            </Dialog>
            {/**Adicionar descrição ao arquivo */}
            <Dialog header="Descrição do Arquivo"
                        visible={this.state.modalDescricaoArquivo} 
                        style={{ width: '40vw' }} 
                        footer={this.renderFooterDescricaoArquivo('modalDescricaoArquivo')}
                        onHide={() => this.fecharModalCadastro('modalDescricaoArquivo')}>

                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <label htmlFor="descricaoArquivo">Descrição</label>
                        <InputText id="descricaoArquivo" 
                              type="text" 
                              style={{width: '100%', height: '32px'}} 
                              value={this.state.descricao}
                              onChange={e => this.setState({descricao: e.target.value})}
                              className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                  </div>
            </Dialog>

            {/**Adicionar descrição ao arquivo temp */}
            <Dialog header="Descrição do Arquivo"
                        visible={this.state.modalDescricaoArquivoTemp} 
                        style={{ width: '40vw' }} 
                        footer={this.renderFooterDescricaoArquivoTemp('modalDescricaoArquivoTemp')}
                        onHide={() => this.fecharModalCadastro('modalDescricaoArquivoTemp')}>

                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <label htmlFor="descricaoArquivo">Descrição</label>
                        <InputText id="descricaoArquivo" 
                              type="text" 
                              style={{width: '100%', height: '32px'}} 
                              value={this.state.descricao}
                              onChange={e => this.setState({descricao: e.target.value})}
                              className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                  </div>
            </Dialog>
            {/**Detalhar Pendentes */}
            <Dialog header="Lançamentos Pendentes"
                      visible={this.state.modalPendentes} 
                      footer={this.renderPendentes} 
                      onHide={() => this.fecharModal('modalPendentes')}>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="formGroup">
                      <label>Categoria</label>
                      <Dropdown value={this.state.pendenteConsultaTipo} style={{width: '100%', height: '32px'}} 
                                options={this.categoria} style={{width: '100%', height: '32px'}}
                                optionLabel="nome" 
                                emptyMessage=" "
                                filter showClear filterBy="nome"
                                onChange={this.onChangeCategoriaConsulta}
                                id="idCategoria"
                                className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <div className="formGroup">
                      <label>Tipo</label>
                      <Dropdown value={this.state.pendenteConsultaTipoCodigo} style={{width: '100%', height: '32px'}} 
                                options={this.state.tipos} style={{width: '100%', height: '32px'}}
                                optionLabel="nome" 
                                filter showClear filterBy="nome"
                                onChange={this.onDespesaChangeConsulta}
                                emptyMessage=" "
                                id="tipoDespesa"
                                className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                  </div>
                  <div className="col-sm-2">
                    <div className="formGroup">
                       <label>&nbsp;</label>
                       <Button className="p-button-info p-button-text p-button-sm" onClick={this.detalharPendentes}>
                        <i className="pi pi-filter"></i>&nbsp;&nbsp;Filtrar</Button>
                    </div>
                  </div>
               </div>
               <br></br>
               <DataTable value={this.state.pendentes}  paginator responsiveLayout="scroll"
                          selection={this.state.selectPendentes} onSelectionChange={(e) => this.setState({ selectPendentes: e.value })}
                          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                          currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" emptyMessage="Nenhum lançamento encontrado" rows={5}>
                          <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} exportable={false}></Column>
                          <Column field="categoria" header="Categoria"></Column>
                          <Column field="tipo.nome" header="Tipo"></Column>
                          <Column field="vlLancamento" header="Valor"></Column>
                          <Column field="dtVencimento" header="Vencimento"></Column>
                          <Column body={this.acoesDespesas} exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
               </DataTable>
            </Dialog>

            {/**Detalhar Vencendo Hoje */}
            <Dialog header="Lançamentos Vencendo Hoje"
                      visible={this.state.modalVencendoHoje} 
                      footer={this.renderPendentes} 
                      onHide={() => this.fecharModal('modalVencendoHoje')}>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="formGroup">
                      <label>Categoria</label>
                      <Dropdown value={this.state.vencendoHojeConsultaTipo} style={{width: '100%', height: '32px'}} 
                                options={this.categoria} style={{width: '100%', height: '32px'}}
                                optionLabel="nome" 
                                emptyMessage=" "
                                onChange={this.onChangeCategoria}
                                id="idCategoria"
                                className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <div className="formGroup">
                      <label>Tipo</label>
                      <Dropdown value={this.state.vencendoHojeConsultaTipoCodigo} 
                                options={this.state.tipos} style={{width: '100%', height: '32px'}}
                                optionLabel="nome" 
                                filter showClear filterBy="nome"
                                onChange={this.onDespesaChange}
                                id="tipoDespesa"
                                className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                  </div>
                  <div className="col-sm-2">
                    <div className="formGroup">
                       <label>&nbsp;</label>
                       <Button className="p-button-info p-button-text p-button-sm" onClick={this.filtrarTipoDespesaPeriodo}>
                        <i className="pi pi-filter"></i>&nbsp;&nbsp;Filtrar</Button>
                    </div>
                  </div>
               </div>
               <br></br>
               <DataTable value={this.state.vencendoHojeLista}  paginator responsiveLayout="scroll"
                          selection={this.state.selectPendentes} onSelectionChange={(e) => this.setState({ selectPendentes: e.value })}
                          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                          currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" emptyMessage="Nenhum lançamento encontrado" rows={5}>
                          <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} exportable={false}></Column>
                          <Column field="categoria" header="Categoria"></Column>
                          <Column field="tipo.nome" header="Tipo"></Column>
                          <Column field="vlLancamento" header="Valor"></Column>
                          <Column field="dtVencimento" header="Vencimento"></Column>
                          <Column body={this.acoesDespesas} exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
               </DataTable>
            </Dialog>
         </section>
        </div>
      </>
    )
  }
}

PainelFinanceiro.contextType = AuthContext;

export default withRouter (PainelFinanceiro)
